if (!customElements.get('new-product-launch')) {
  class NewProductLaunch extends HTMLElement {
    swiper;

    connectedCallback() {
      const container = this.querySelector('.new-product-launch__swiper');
      if (!container || typeof Swiper === 'undefined') return;

      this.swiper = new Swiper(container, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: true,
        autoHeight: true,
        observeParents: true,
        observeSlideChildren: true,
        observer: true,
        resizeObserver: true,
        navigation: {
          nextEl: this.querySelector('.swiper-btn-next'),
          prevEl: this.querySelector('.swiper-btn-prev')
        },
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true
        }
      });
    }
  }

  customElements.define('new-product-launch', NewProductLaunch);
}
